import ScrollReveal from 'scrollreveal';
import Swiper from 'swiper';
export default {
  init() {
    // JavaScript to be fired on all pages

    /*
    * Track a form submission with Google Analytics
    * Keep in mind that the tracking code must be enabled to let this work properly
    */

    /* eslint-disable */
    // document.addEventListener( 'wpcf7mailsent', function( event ) {
    //   ga( 'send', 'event', 'Contact Form', 'submit' );
    // }, false );
    /* eslint-enable */
      var audio_radio = new Audio() ;
      var audio_radio_isPlayed = false;
      var audio_radio_isMuted = false;


      audio_radio.src='https://azura.citradio.net/radio/8000/radio';
      audio_radio.volume = 0.75

      $(".play--button").click(function(){
          if (audio_radio_isPlayed){
              audio_radio.pause();
              audio_radio_isPlayed = false;
              $(".play-pause-icon").addClass("fa-play");
              $(".play-pause-icon").removeClass("fa-pause");
          }else{
              audio_radio.play();
              audio_radio_isPlayed = true;
              $(".play-pause-icon").addClass("fa-pause");
              $(".play-pause-icon").removeClass("fa-play");
          }
      });

      $(".mute--button").click(function(){
          if (audio_radio_isMuted){
              audio_radio.muted = false;
              audio_radio_isMuted = false;
              $(".mute-icon").addClass("fa-volume-up");
              $(".mute-icon").removeClass("fa-volume-off");
          }else{
              audio_radio.muted = true;
              audio_radio_isMuted = true;
              $(".mute-icon").addClass("fa-volume-off");
              $(".mute-icon").removeClass("fa-volume-up");
          }
      });


      $("#player_radio_value").mouseup(function(){
          var x_volume = document.getElementById("player_radio_input_slider_value").textContent;
          audio_radio.volume = x_volume/100 ;
      });
      $("#player_radio_value_bar").mouseout(function(){
          var x_volume = document.getElementById("player_radio_input_slider_value").textContent;
          audio_radio.volume = x_volume/100 ;
      });

      $(function(){
          $(window).scroll(function(){
              if ($(this).scrollTop() > parseInt( 50 + 0 ) ) {
                  $('header .header__fixed').addClass('fixed');
              } else {
                  $('header .header__fixed').removeClass('fixed');
              }

          });
      });

      var swiper = new Swiper('.swiper__container', {
          slidesPerView: 1,
          spaceBetween: 30,
          wrapperClass: 'swiper__wrapper',
          slideClass: 'swiper__slide',
          speed: 1000,
          autoplay: {
              delay: 5000,
          },
          loop: true,
          pagination: {
              clickable: true,
          },
      });

      window.sr = ScrollReveal({reset: true});
      window.sr.reveal('.reveal', {
          duration: 700,
          opacity: 0,
          delay: 200,
          origin:'bottom',
          distance:'20px',
          reset: false,
          easing: 'ease-in-out',
          mobile: false,
          viewOffset: { top: 0, right: 0, bottom: 0, left: -100 },
      });

      window.sr = ScrollReveal({reset: true});
      window.sr.reveal('.reveal-slow', {
          duration: 700,
          opacity: 0,
          delay: 500,
          origin:'bottom',
          distance:'20px',
          reset: false,
          easing: 'ease-in-out',
          mobile: false,
          viewOffset: { top: 0, right: 0, bottom: 0, left: -100 },
      });

      window.sr = ScrollReveal({reset: true});
      window.sr.reveal('.gutenberg__content h1', {
          duration: 700,
          opacity: 0,
          delay: 200,
          origin:'bottom',
          distance:'20px',
          reset: false,
          easing: 'ease-in-out',
          mobile: false,
          viewOffset: { top: 0, right: 0, bottom: 0, left: -100 },
      });

      window.sr = ScrollReveal({reset: true});
      window.sr.reveal('.gutenberg__content h2', {
          duration: 700,
          opacity: 0,
          delay: 200,
          origin:'bottom',
          distance:'20px',
          reset: false,
          easing: 'ease-in-out',
          mobile: false,
          viewOffset: { top: 0, right: 0, bottom: 0, left: -100 },
      });

      window.sr = ScrollReveal({reset: true});
      window.sr.reveal('.gutenberg__content p', {
          duration: 700,
          opacity: 0,
          delay: 200,
          origin:'bottom',
          distance:'20px',
          reset: false,
          easing: 'ease-in-out',
          mobile: false,
          viewOffset: { top: 0, right: 0, bottom: 0, left: -100 },
      });

      window.sr = ScrollReveal({reset: true});
      window.sr.reveal('.gutenberg__content .wp-block-columns', {
          duration: 700,
          opacity: 0,
          delay: 200,
          origin:'bottom',
          distance:'20px',
          reset: false,
          easing: 'ease-in-out',
          mobile: false,
          viewOffset: { top: 0, right: 0, bottom: 0, left: -100 },
      });

      $(function() {
          $('.header__toggle--menu').on('click', function(){
              $('.mobile__menu').toggleClass('open');
              $('.header__toggle--menu').toggleClass('open');
          })
      });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js